import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "react-select";
const AddAdminModal = ({ show, onClose, onSubmit }) => {
  const [loms, setLoms] = useState([]);
  const [formData, setFormData] = useState({
    membership_id: "",
    admin_name: "",
    lom_name: "",
    contact_number: "",
    whatsapp_number: "",
  });
  useEffect(() => {
    fetchLoms();
  }, []);
  const fetchLoms = async () => {
    try {
      const response = await axios.get("/lom/read");
      setLoms(response.data);
    } catch (error) {
      console.error("Error fetching LOM Presidents:", error);
    }
  };
  const lomoptions = [
    ...loms.map((lom) => ({
      value: lom.lom_id,
      label: lom.lom_name,
    })),
  ];
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  const handleLomChange = (selected) => {
    // Store only the selected value, not an array
    setFormData((prevState) => ({
      ...prevState,
      lom_name: selected ? selected.value : "", // If selected, set the value; otherwise, set an empty string
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      // POST request to your backend to create a new Admin
      const response = await axios.post("/admin/create", formData);
      console.log("Admin added:", response.data);

      Swal.fire({
        icon: "success",
        title: "Admin Added",
        text: "The Admin has been added successfully!",
        confirmButtonText: "Okay",
      });

      onSubmit(formData); // Refresh Contests after successful addition
      onClose(); // Close the Add Admin popup
    } catch (err) {
      setError(err.response?.data?.error || "Failed to add Admin");
    } finally {
      setLoading(false);
    }
  };
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50">
      <div className="bg-white p-6 max-w-2xl w-full rounded shadow-lg">
        <h2 className="text-lg font-bold mb-4">Add LOM President</h2>
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* LOM Name */}
            <div>
              <label className="block text-sm font-medium mb-1">LOM Name</label>
              <Select
                name="lom_name"
                value={
                  formData.lom_name
                    ? lomoptions.find(
                        (option) => option.value === formData.lom_name.value
                      )
                    : null
                } // Find the selected option object
                onChange={handleLomChange}
                options={lomoptions}
                className="w-full p-2 border rounded-lg"
                required
              ></Select>
            </div>
            {/* Year */}
            {/* <div>
              <label className="block text-sm font-medium mb-1">Year</label>
              <input
                type="number"
                name="year"
                value={formData.year}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
            </div> */}
            {/* Name */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Admin Name
              </label>
              <input
                type="text"
                name="admin_name"
                value={formData.admin_name}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
            </div>
            {/* Member ID */}
            <div>
              <label className="block text-sm font-medium mb-1">
                MemberShip ID
              </label>
              <input
                type="text"
                name="membership_id"
                value={formData.membership_id}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
            </div>
            {/* Contact Number */}
            <div>
              <label className="block text-sm font-medium mb-1">
                Contact Number
              </label>
              <input
                type="text"
                name="contact_number"
                value={formData.contact_number}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">
                Whatsapp Number
              </label>
              <input
                type="text"
                name="whatsapp_number"
                value={formData.whatsapp_number}
                onChange={handleChange}
                required
                className="w-full border rounded px-3 py-2"
              />
            </div>
          </div>
          <div className="flex justify-end mt-4">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-300 text-black px-4 py-2 rounded mr-2"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-blue-500 text-white px-4 py-2 rounded"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddAdminModal;
